import { Component, Host, h, Prop } from '@stencil/core';
import informationIcon from '../../assets/svg/information-line.svg';

@Component({
  tag: 'salla-alert',
  styleUrl: 'salla-alert.scss',
})
export class SallaAlert {
  /** Message text */
  @Prop() message: string;

  /** Variant theme */
  @Prop() variant: 'info' | 'success' | 'warning' | 'error' = 'info';

  /** Icon type (defaults to variant) */
  @Prop() icon?: 'info' | 'success' | 'warning' | 'error' | 'none';

  private renderIcon() {
    const type = this.icon || this.variant;

    if (type === 'none') return null;

    switch (type) {
      case 'success':
        return (
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M9 16.2l-3.5-3.5L4 14.2l5 5 11-11-1.5-1.5z" />
          </svg>
        );
      case 'warning':
        return (
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
        );
      case 'error':
        return (
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 
                     10 10 10-4.48 10-10S17.52 2 12 2zm5 
                     13.59L15.59 17 12 13.41 8.41 17 
                     7 15.59 10.59 12 7 8.41 8.41 7 
                     12 10.59 15.59 7 17 8.41 13.41 
                     12 17 15.59z"
            />
          </svg>
        );
      default:
        return <span innerHTML={informationIcon}></span>;
    }
  }

  render() {
    return (
      <Host class={`s-alert-wrapper s-alert-${this.variant}`}>
        <span class="s-alert-icon">{this.renderIcon()}</span>
        <span class="s-alert-text">
          {this.message}
          <slot></slot>
        </span>
      </Host>
    );
  }
}
